import { render } from "./EditReportDialog.vue?vue&type=template&id=5edb94c2&scoped=true"
import script from "./EditReportDialog.vue?vue&type=script&lang=js"
export * from "./EditReportDialog.vue?vue&type=script&lang=js"

import "./EditReportDialog.vue?vue&type=style&index=0&id=5edb94c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edb94c2"]])

export default __exports__